import React from 'react';
import { Card, Table, Button, Menu, Dropdown, Icon, Popconfirm, message, Tag } from 'antd';
import Title from '../../component/title';
import useTable from '../../component/table';
import { MyLink, push } from '../../component/link';
import Fetch from '../../Fetch';
import { paymentTypeToString, paymentTypeToColor, paymentType } from '../../constant'

const Actions = props => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button.Group>
                <Button type="primary" href={'/voucher/add'} onClick={(e) => {
                    e.preventDefault();
                    push(props, `/voucher/add`);
                }}>Tambah</Button>
                <Button icon="reload" onClick={props.onRefresh}></Button>
            </Button.Group>
        </div>
    );
}

const Voucher = props => {
    const [, tb] = useTable('/voucher', { order: { key: '_id', order: 'desc' } })

    const onConfirm = (id) => {
        return async () => {
            try {
                await Fetch.del(`/voucher/${id}`);
                message.info("Berhasil menghapus voucher");
                tb.fetchData();
            } catch (err) {
                message.error("Error menghapus voucher: " + err);
            }
        }
    }

    const onRow = (record) => {
        return {
            onDoubleClick: () => {
                push(props, `/voucher/${record.id}`);
            }
        }
    }

    const actionMenus = (record) => (
        <Menu>
            <Menu.Item><MyLink to={`/voucher/${record.id}/edit`}><Icon type="edit" style={{ marginRight: 8 }} />Edit</MyLink></Menu.Item>
            <Menu.Item>
                <Popconfirm placement="bottomRight" title={`Yakin menghapus ${record.title}?`} onConfirm={onConfirm(record.id)} okText="Iya" cancelText="Tidak">
                    <span className="span-click2"><Icon type="delete" style={{ marginRight: 8 }} />Hapus</span>
                </Popconfirm>
            </Menu.Item>
        </Menu>
    )

    return (
        <Card title={<Title title={"Daftar voucher"} actions={<Actions {...props} onRefresh={() => tb.fetchData()} />} />}>
            <Table {...tb.tableProps} onRow={onRow}>
                <Table.Column key="title" dataIndex="title" title="Judul" {...tb.columnProps({ key: 'title', hint: 'Cari judul' })} />
                <Table.Column key="description" dataIndex="description" title="Deskripsi" />
                <Table.Column key="year.name" dataIndex="year" title="Tahun ajaran" render={(t) => t == null ? '-' : t.name} />
                <Table.Column key="payment_type" dataIndex="payment_type" title="Tipe" width={200} render={t => <Tag color={paymentTypeToColor(t)}>{paymentTypeToString(t)}</Tag>}
                    {...tb.columnProps({ key: 'type', type: 'radio', options: paymentType, })} />
                <Table.Column key="amount" dataIndex="amount" title="Nilai" align="right" render={(t) => t.toLocaleString('in-ID')} />
                <Table.Column key="active" dataIndex="active" title="Aktif" render={(t, r) => {
                    return <Tag color={t ? 'green' : 'red'}>{t ? 'Aktif' : 'Non aktif'}</Tag>
                }}
                    {...tb.columnProps({ key: 'active', type: 'radio', options: [{ text: 'Aktif', value: 1 }, { text: 'Non aktif', value: 0 }] })} />
                <Table.Column key="action" title="Aksi" align="center" render={(t, r) => {
                    return <Dropdown overlay={actionMenus(r)} trigger={['click']}><span className="span-click" >aksi</span></Dropdown>
                }} />
            </Table>
        </Card >
    )
}

export default Voucher;